import instance from "services";
import {RastreamentoLogFilter} from "../../../filters/rastreamento-log-filter";
import parseBlobError from "../../parse-blob-error";

export default async function GetRastreamentoLogsExcel(filter: RastreamentoLogFilter): Promise<Blob> {
    try {
        const response = await instance.get('/v1/backoffice/logs/excel', {
            params: filter,
            responseType: 'blob',
        });
        return response.data;
    } catch (error) {
        return parseBlobError(error, 'Falha ao exportar logs.');
    }
}
